<template>
  <v-dialog v-model="showDialog" max-width="300px">
    <v-card>
      <v-card-title class="headline" v-if="this.title !== null">
        {{ title }}
      </v-card-title>

      <v-card-text>
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="error" v-if="!confirmOnly" @click="closeDialog(false)">
          {{ cancelText }}
        </v-btn>

        <v-btn color="primary" @click="closeDialog(true)">
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    confirmText: {
      type: String,
      default: "OK"
    },
    cancelText: {
      type: String,
      default: "No"
    },
    title: {
      type: String,
      default: "Confirm"
    },
    message: {
      type: String,
      default: "Are you sure you want to continue?"
    },
    confirmOnly: {
      type: Boolean,
      default: true
    },
    confirmedEvent: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      showDialog: true
    };
  },
  methods: {
    closeDialog(status) {
      this.showDialog = false;

      if (this.confirmedEvent) {
        this.$emit(this.confirmedEvent, status);
      } else {
        this.$emit("confirmed", status);
      }
    }
  }
};
</script>
